var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCombine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1772_11791)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8855 50.5709C19.6707 50.5709 21.1178 48.9844 21.1178 47.0274C21.1178 45.0704 19.6707 43.4839 17.8855 43.4839C16.1004 43.4839 14.6532 45.0704 14.6532 47.0274C14.6532 48.9844 16.1004 50.5709 17.8855 50.5709ZM17.8855 54.3506C20.7806 54.3506 23.2456 52.3315 24.1727 49.5078C24.4271 48.7332 24.5656 47.898 24.5656 47.0274C24.5656 46.584 24.5297 46.1498 24.4608 45.7281C23.9015 42.3034 21.1704 39.7042 17.8855 39.7042C14.6006 39.7042 11.8695 42.3034 11.3102 45.7281C11.2413 46.1498 11.2054 46.584 11.2054 47.0274C11.2054 47.898 11.344 48.7332 11.5983 49.5078C12.5254 52.3315 14.9904 54.3506 17.8855 54.3506Z",
    fill: "url(#paint0_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1804 25.7659C13.1804 24.6569 14.0005 23.9941 15.0121 23.9941H22.4895C23.5011 23.9941 24.3211 24.6569 24.3211 25.7659C24.3211 26.8748 23.5011 27.5376 22.4895 27.5376H15.0121C14.0005 27.5376 13.1804 26.8748 13.1804 25.7659Z",
    fill: "url(#paint1_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3528 27.1242C30.0371 26.374 30.0371 25.1577 29.3528 24.4075C28.6685 23.6573 27.559 23.6573 26.8747 24.4075C26.1904 25.1577 26.1904 26.374 26.8747 27.1242C27.559 27.8744 28.6685 27.8744 29.3528 27.1242Z",
    fill: "url(#paint2_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5986 46.9086C45.2829 46.1584 45.2829 44.9421 44.5986 44.1919C43.9143 43.4417 42.8048 43.4417 42.1205 44.1919C41.4361 44.9421 41.4361 46.1584 42.1205 46.9086C42.8048 47.6588 43.9143 47.6588 44.5986 46.9086Z",
    fill: "url(#paint3_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50842 20.8057C2.34149 20.8057 3.01683 20.0653 3.01683 19.1521C3.01683 18.2388 2.34149 17.4984 1.50842 17.4984C0.675341 17.4984 -1.41872e-08 18.2388 0 19.1521C1.41872e-08 20.0653 0.675341 20.8057 1.50842 20.8057Z",
    fill: "url(#paint4_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9899 17.7347C7.41957 17.7347 4.52525 20.9076 4.52525 24.8216V33.2078C4.52525 34.2871 5.1254 35.2126 5.9798 35.6053V46.673C5.9798 48.2386 7.13752 49.5078 8.56565 49.5078H11.5983C11.344 48.7332 11.2054 47.898 11.2054 47.0274C11.2054 46.584 11.2413 46.1498 11.3102 45.7281H9.42761V36.0106C9.52325 36.0335 9.61855 36.0584 9.71345 36.0851L11.3994 36.5668L30.1066 41.7202C31.569 42.1568 33.1294 41.6196 34.1015 40.3449L37.8058 35.4878C38.0514 35.1657 38.4147 34.9796 38.7977 34.9796H42.9904C43.7044 34.9796 44.2833 34.345 44.2833 33.5622V32.4991H46.2222H48.5735C48.947 32.4991 49.3137 32.4602 49.67 32.3854C51.8947 31.9184 53.7127 30.0552 54.2406 27.5647L56.7501 15.7267H56.8893C57.8414 15.7267 58.6132 14.8806 58.6132 13.8369C58.6132 12.7931 57.8414 11.947 56.8893 11.947H36.4247C35.5994 11.947 34.8238 12.3788 34.3369 13.1092L32.6372 16.3677C32.1319 17.1257 31.0335 17.3362 30.1911 16.6215C26.9964 13.307 22.0694 9.52741 16.4853 9.52734C10.4053 9.52727 6.12309 9.85736 2.68764 11.1127C1.78441 11.4428 1.29627 12.5131 1.59735 13.5032C1.89843 14.4934 2.87471 15.0285 3.77794 14.6985C6.80713 13.5915 10.7135 13.307 16.4853 13.307C20.3883 13.3071 23.2055 15.5467 26.1499 17.7347H10.9899ZM40.835 17.7347V21.5144H10.9899C9.32374 21.5144 7.97306 22.9951 7.97306 24.8216V32.0301C8.84999 32.0526 9.722 32.1849 10.5721 32.4245L12.3053 32.9199L31.0125 38.0733C31.175 38.1219 31.3484 38.0622 31.4564 37.9205L35.1607 33.0634C36.0614 31.8824 37.3934 31.1999 38.7977 31.1999H40.8355V27.6564H33.5089C32.5568 27.6564 31.785 26.8103 31.785 25.7665C31.785 24.7228 32.5568 23.8767 33.5089 23.8767H40.8355V15.7267H36.8624L35.5239 17.7347H40.835ZM44.2833 28.7194H48.5735C49.6759 28.7194 50.6328 27.8863 50.8823 26.7091L53.2104 15.7267H44.2833V28.7194Z",
    fill: "url(#paint5_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5555 45.8462C35.5555 45.8068 35.5558 45.7674 35.5563 45.7281H24.4608C24.5297 46.1498 24.5656 46.584 24.5656 47.0274C24.5656 47.898 24.4271 48.7332 24.1727 49.5078H36.3094C35.8261 48.3989 35.5555 47.1572 35.5555 45.8462Z",
    fill: "url(#paint6_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1804 25.7659C13.1804 24.6569 14.0005 23.9941 15.0121 23.9941H22.4895C23.5011 23.9941 24.3211 24.6569 24.3211 25.7659C24.3211 26.8748 23.5011 27.5376 22.4895 27.5376H15.0121C14.0005 27.5376 13.1804 26.8748 13.1804 25.7659ZM29.3528 24.4075C30.0371 25.1577 30.0371 26.374 29.3528 27.1242C28.6685 27.8744 27.559 27.8744 26.8747 27.1242C26.1904 26.374 26.1904 25.1577 26.8747 24.4075C27.559 23.6573 28.6685 23.6573 29.3528 24.4075Z",
    fill: "url(#paint7_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7001 34.0347H49.67V32.3854C49.3137 32.4602 48.947 32.4991 48.5735 32.4991H46.2222V37.9601C47.6203 38.5805 48.8159 39.6348 49.67 40.9706V37.8144H51.7001L54.7817 41.5941H50.0329C50.6254 42.7169 50.9904 44.002 51.0589 45.3738H57.8634L59.5005 47.3817H50.9446C50.7096 48.7943 50.1563 50.085 49.3692 51.1614H61.427C63.6616 51.1614 64.8441 48.264 63.355 46.4375L54.2707 35.2955C53.6166 34.4933 52.6816 34.0347 51.7001 34.0347Z",
    fill: "url(#paint8_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5986 46.9086C45.2829 46.1584 45.2829 44.9421 44.5986 44.1919C43.9143 43.4417 42.8048 43.4417 42.1205 44.1919C41.4361 44.9421 41.4361 46.1584 42.1205 46.9086C42.8048 47.6588 43.9143 47.6588 44.5986 46.9086Z",
    fill: "url(#paint9_linear_1772_11791)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5563 45.7281C35.5558 45.7674 35.5555 45.8068 35.5555 45.8462C35.5555 47.1572 35.8261 48.3989 36.3094 49.5078C37.5576 52.3719 40.2246 54.3506 43.3131 54.3506C45.7629 54.3506 47.9475 53.1057 49.3692 51.1614C50.1563 50.085 50.7096 48.7943 50.9446 47.3817C51.0274 46.8837 51.0707 46.3705 51.0707 45.8462C51.0707 45.6877 51.0667 45.5302 51.0589 45.3738C50.9904 44.002 50.6254 42.7169 50.0329 41.5941C49.92 41.3802 49.7989 41.1722 49.67 40.9706C48.8159 39.6348 47.6203 38.5805 46.2222 37.9601C45.3238 37.5614 44.3419 37.3419 43.3131 37.3419C39.0647 37.3419 35.6139 41.0857 35.5563 45.7281ZM43.3131 41.1216C40.9329 41.1216 39.0034 43.2369 39.0034 45.8462C39.0034 48.4556 40.9329 50.5709 43.3131 50.5709C44.4343 50.5709 45.4556 50.1015 46.2222 49.3322C47.083 48.4684 47.6229 47.2264 47.6229 45.8462C47.6229 44.466 47.083 43.2241 46.2222 42.3603C45.4556 41.591 44.4343 41.1216 43.3131 41.1216Z",
    fill: "url(#paint10_linear_1772_11791)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1772_11791",
    x1: 32.009,
    y1: 9.52734,
    x2: 32.009,
    y2: 54.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060114"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1772_11791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCombine);
export default __webpack_public_path__ + "static/media/BlackCombine.595fa4b8c378772283c89f30c05c0307.svg";
export { ForwardRef as ReactComponent };